module.exports = __webpack_public_path__ + "images/FUSA_icons/031-invoice-1.51e185db7987a5898c2bb25e3b8c0a49.svg";